import React, {useState} from 'react';
import {BrowserRouter, Route, Routes, useNavigate} from 'react-router-dom';
import NavbarWithSearch from "./components/NavbarWithSearch";
import HomePage from "./pages/HomePage";
import SearchPage from "./pages/SearchPage";
import {AuthProvider} from "./contexts/AuthContext";

function App() {
    return (
        <AuthProvider>
            <BrowserRouter 
                basename={process.env.PUBLIC_URL}
                future={{
                    v7_startTransition: true,
                    v7_relativeSplatPath: true,
                }}
            >
                <NavbarWithSearch/>
                <div className="d-flex justify-content-center py-4">
                    <div style={{width: '1320px'}}>
                        <Routes>
                            <Route path="/" element={<HomePage/>}/>
                            <Route path="/search" element={<SearchPage/>}/>
                        </Routes>
                    </div>
                </div>
            </BrowserRouter>
        </AuthProvider>
    );
}

export default App;
